import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription, timer} from 'rxjs';
import {delay, filter, finalize} from 'rxjs/operators';

import {GetJasoFromString, JASO} from '../shared/defines/gukeo.const';
import {
  DETAIL_POPUP_DELAY,
  HISTORY_KEY_SEARCH_SASEUNG,
  LIST_TYPE,
  SASEUNG_SCROLL_SPEED,
  SearchParam,
  triggerDetailPopup,
  UI_RELOAD_HEIGHT,
} from '../shared/defines/client.const';
import {IsEqualObj1} from "../shared/defines/common.func";
import {ListLoader} from '../shared/interfaces/list-loader';
import {LayoutMgrService} from '../shared/services/layout-mgr/layout-mgr.service';
import {GetSearchFromQuery} from "../shared/defines/client.func";
import {NormalizeSearchKeyword, NormalizeSearchParamKeyword} from '../shared/defines/search-keyword.func';
import {GlobalEventService} from "../shared/services/global-event/global-event.service";
import {ScrollDownService} from "../shared/services/scroll-down/scroll-down.service";
import {Saseung3HangulService} from "../shared/services/saseung3-hangul/saseung3-hangul.service";


@Component({
  selector: 'app-saseung3',
  templateUrl: './saseung3.component.html',
  styleUrls: ['./saseung3.component.scss'],
  animations: [triggerDetailPopup],
})
export class Saseung3Component implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;
  @ViewChild('reload') reload: ElementRef;

  readonly HISTORY_KEY_SEARCH_SASEUNG = HISTORY_KEY_SEARCH_SASEUNG;

  private inited = false;
  public type: LIST_TYPE = LIST_TYPE.SERVER;
  private bookmarkDetailClosed = false;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;

  // 해더에 넣는 값
  public curJasoIdx: JASO | null = null;
  public keyword: string = null;

  // ListLoader 설정
  ll: ListLoader<string>;

  // 상세화면 표시 관련 정의
  public showDetail = false;
  private getNextList$: Subscription = null;
  public curHangul: string | null = null; // 현재 선택된 단어
  public curKeyword: string | null = null; // 현재 선택된 검색어
  public curHun: string | null = null; // 현재 선택된 훈
  public curHanja: string | null = null; // 현재 선택된 한자

  public showHunDetail = false;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private saseung3HangulSvc: Saseung3HangulService,
    private scrollDownSvc: ScrollDownService,
    private globalEventSvc: GlobalEventService,
    public lm: LayoutMgrService,
  ) {

    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams.subscribe(params => {
      console.warn('route.queryParams.subscribe(params =', params);
      const oldParams = {...this.queryParams};
      this.queryParams = NormalizeSearchParamKeyword({...params});
      delete this.queryParams.serial;
      this.type = this.queryParams?.l ?? LIST_TYPE.SERVER;
      if (this.type !== LIST_TYPE.BOOKMARK || this.hasDetailQueryParam(this.queryParams)) {
        this.bookmarkDetailClosed = false;
      }

      this.curKeyword = null;
      this.curHangul = null;
      this.curHun = null;
      this.curHanja = null;

      if (this.inited) { // 이미 화면이 초기화되어있는 경우

        if ('hanja' in this.queryParams) {
          const hanja = this.queryParams.hanja;

          this.CloseDetail();
          timer(DETAIL_POPUP_DELAY).subscribe(() => {
            this.curHanja = hanja;
            this.keyword = null;
            this.OpenDetail();
          });
        } else if ('hun' in this.queryParams) {
          const hun = this.queryParams.hun;

          this.CloseDetail();
          timer(DETAIL_POPUP_DELAY).subscribe(() => {
            this.curHun = hun;
            this.keyword = null;
            this.OpenDetail();
          });
        } else if ('keyword' in this.queryParams) {
          // 키워드 검색
          const keyword = NormalizeSearchKeyword(this.queryParams.keyword);
          if (this.curKeyword === keyword) {
            // 이미 같은 keyword가 있으면 무시
            return;
          }

          this.CloseDetail();
          timer(DETAIL_POPUP_DELAY).subscribe(() => {
            this.keyword = keyword;
            this.curKeyword = keyword;
            this.OpenDetail();
          });
        } else if ('id' in this.queryParams) {
          // id 는 한글 검색임.
          const id = this.queryParams.id;

          const processParams = () => {
            // console.warn('processParams()');
            const hangul = this.ll.getById(id) ?? null;
            if (hangul) {
              this.CloseDetail();
              timer(DETAIL_POPUP_DELAY).subscribe(() => {
                this.curHangul = hangul;
                this.curKeyword = null;
                this.OpenDetail();
              });
            } else {
              // 존재하지 않으면 다른 자소색인을 로딩한 후 연다.
              const jaso: JASO = GetJasoFromString(id);
              console.warn('does not exist hangul', id, jaso);
              this.queryParams.index = jaso;
              this.init();
            }
          };

          if (this.ll.IsLoading()) {
            // 이 시점에서 아직 목록 로딩이 안 끝났을 수 있다.
            this.ll.GetNextList().pipe(
              delay(DETAIL_POPUP_DELAY),
            ).subscribe(processParams);
          } else {
            processParams();
          }
        } else {

          const params = {...oldParams}
          delete params.id;
          if (IsEqualObj1(params, this.queryParams)) {
            // 기존의 값과 id 만 차이 난다면, 현재 상세 팝업창을 닫는다.
            this.CloseDetail();
          } else {
            // 기존의 파라미터와 다르면, 다시 로딩한다.
            this.init();
          }
        }
      }
    });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.routeParams$ = route.params.subscribe(params => {
      // console.warn('params =', params);

      this.inited = true;

      this.init();
    });

    lm.Reset();
  }

  ngOnInit(): void {
    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      if (isFirst && this.type !== LIST_TYPE.BOOKMARK) {
        this.onCloseItem();
      }
      const scrollDelta = SASEUNG_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });
  }

  ngOnDestroy(): void {
    // 화면전환시 라우팅을 위해서 히스토리 저장
    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }
  }

  private init(): void {
    // console.warn('init()', this.queryParams);

    this.bookmarkDetailClosed = false;
    this.ll = this.saseung3HangulSvc;

    let param: SearchParam;
    [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);
    this.ReloadList(param);
  }

  /****************************************************************************
   * 단어 목록 로딩 처리.
   ****************************************************************************/
  public onSearch(param: SearchParam): void {
    this.router.navigate(['/saseung'], {
      queryParams: {...NormalizeSearchParamKeyword(param), l: LIST_TYPE.SERVER},
    }).then();
  }

  public ReloadList(param: SearchParam): void {
    this.ll.ResetList(NormalizeSearchParamKeyword(param));
    this.loadList(true);

    // 상세 팝업창이 열려있다면 닫는다.
    if (this.showDetail) {
      this.CloseDetail();
    }
  }

  private loadList(cancel = false): void {
    if (this.getNextList$) {
      console.warn('Saseung3Component::loadList() already call loadList!');
      if (cancel) {
        this.getNextList$.unsubscribe();
      } else {
        return;
      }
    }

    if (this.ll.IsComplete()) {
      console.warn('Saseung3Component::loadList() already load all word!');
      return;
    }

    // 첫번째 로딩 시 위치 계산을 해야 한다.
    this.getNextList$ = this.ll.GetNextList().pipe(
      filter(ret => ret?.first),
      delay(DETAIL_POPUP_DELAY),
      finalize(() => this.getNextList$ = null)
    ).subscribe(() => {
      /**
       * 라우터 주소로 바로 들어왔을 때, 단어 상세 팝업창을 열어야 하는 경우
       * NOTE: 중복해서 OpenDetail() 함수가 불려지는 것이 아닌지 확인함.
       */
        console.warn('Saseung3Component::loadList() done', this.queryParams);
        if (this.queryParams && 'id' in this.queryParams) {
          const hangul = this.ll.getById(this.queryParams.id);
          if (hangul) {
            this.curHangul = hangul;
            this.OpenDetail();
          }
        } else if (this.queryParams && 'keyword' in this.queryParams) {
          this.curKeyword = this.queryParams.keyword;
          this.curHangul = null;
          this.OpenDetail();
        } else if (this.queryParams && 'hun' in this.queryParams) {
          this.curHun = this.queryParams.hun;
          this.OpenDetail();
        } else if (this.queryParams && 'hanja' in this.queryParams) {
          this.curHanja = this.queryParams.hanja;
          this.OpenDetail();
        } else if (this.shouldOpenBookmarkDetail()) {
          this.OpenDetail();
        }
      }
    );
  }

  /****************************************************************************
   * 일정 범위 이상 스크롤되면 남은 단어를 자동 로딩한다.
   ****************************************************************************/
  onScroll($event): void {
    if (!this.ll.IsLoading() && !this.ll.IsComplete()) {
      const tar = $event.target || $event.srcElement || $event.currentTarget;
      if (tar !== this.container.nativeElement) {
        console.error('Saseung3Component::onScroll() - wrong structure!!');
      }

      const elReload = this.reload.nativeElement;

      if (elReload.offsetTop < window.innerHeight + tar.scrollTop + UI_RELOAD_HEIGHT) {
        this.loadList();
      }
    }
  }


  /****************************************************************************
   * 단어 상세 팝업창 처리 코드
   ***************************************************************************/

  async onSelectItem($event: MouseEvent, hangul: string) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // 이미 열려있으면 무시
    if (this.showDetail) {
      console.warn('onSelectItem() already opened!');
      return;
    }

    const queryParams = {
      ...this.queryParams,
      id: hangul,
      l: LIST_TYPE.SERVER,
    };
    await this.router.navigate(['/saseung'], {queryParams});
  }

  async onCloseItem() {
    // 이미 닫혀있으면 무시
    if (!this.showDetail) {
      console.warn('onCloseItem() already closed!');
      return;
    }

    if (this.shouldOpenBookmarkDetail()) {
      this.bookmarkDetailClosed = true;
      this.CloseDetail();
      return;
    }

    // 현재 쿼리 파라미터에서 id, keyword, hun, hanja 를 제외한 나머지 파라미터를 보낸다.
    const { id, keyword, hun, hanja, ...restQueryParams } = this.queryParams;
    const queryParams = {
      ...restQueryParams,
      l: this.type,
    };

    await this.router.navigate(['/saseung'], {queryParams});
  }

  /**
   * 사성 상세 보기
   */
  public OpenDetail($event: MouseEvent = null): void {
    if (this.showDetail) {
      // 이미 열려있으면 무시
      console.warn('OpenDetail() already opened!');
      return;
    }

    this.showDetail = true;
  }

  /**
   * 상세 팝업창을 닫았을 때의 이벤트 처리 함수
   */
  public CloseDetail(): void {
    console.log('CloseDetail()');

    this.showDetail = false;
    this.curHangul = null;
  }

  /****************************************************************************
   * 사성알림 도움말 팝업
   ***************************************************************************/
  public OpenHelp() {
    this.lm.showHelp = true;
  }

  public CloseHelp(): void {
    this.lm.showHelp = false;
  }

  private shouldOpenBookmarkDetail(): boolean {
    return this.type === LIST_TYPE.BOOKMARK &&
      !this.bookmarkDetailClosed &&
      !this.hasDetailQueryParam(this.queryParams);
  }

  private hasDetailQueryParam(params: SearchParam | null): boolean {
    return !!params &&
      ('id' in params || 'keyword' in params || 'hun' in params || 'hanja' in params);
  }
}
